import { render, staticRenderFns } from "./PushConfigDetail.vue?vue&type=template&id=052fa668&"
import script from "./PushConfigDetail.vue?vue&type=script&lang=js&"
export * from "./PushConfigDetail.vue?vue&type=script&lang=js&"
import style0 from "./PushConfigDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports